import * as constants from '../constants';

export default function (state = [], action) {
  switch (action.type) {
    case constants.GET_OPTIONS_BY_FILTERS_SUCCESS:
    case constants.GET_OPTIONS_SUCCESS:
      return Object.assign({},
        state, {
          options: action.options,
        });
    case constants.GET_OPTIONS_BY_FILTERS_ERROR:
    case constants.GET_OPTIONS_ERROR:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};
